export const catCiudad = Object.freeze({
    NO_APLICA: 35527,
})